// extracted by mini-css-extract-plugin
export default {"header":"LoginFormLayout_header__Q8r02","container":"LoginFormLayout_container__MeB9l","wrapper":"LoginFormLayout_wrapper__iG-xc","supportText":"LoginFormLayout_supportText__qwCOn"};